import script from "./newContact.vue?vue&type=script&setup=true&lang=js"
export * from "./newContact.vue?vue&type=script&setup=true&lang=js"

import "./newContact.vue?vue&type=style&index=0&id=233b39df&scoped=true&lang=css"
import "./newContact.vue?vue&type=style&index=1&id=233b39df&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233b39df"]])

export default __exports__